export class DeliveryPackage {
    id: number;
    ownerUserId: number;
    ownerUserName: string | null; // Nome do destinatario
    delivedToUserId: number;
    deliveredToUserName: string | null; // Quem recebeu a encomenda / usuario do app
    deliveredByUserId: string | null;
    deliveredByUserName: string | null; // funcionario logado que entregou a encomenda
    registredByUserId: number;
    registeredByUserName: string | null; // Quem registrou a encomenda
    packageB64Photo: string [];
    description: string | null;
    registeredAt: string | null; //Date = null;
    deliveredAt: string | null; //Date = null;
    deliveryStatus: string | null;
    deliveryUnit: string | null;

    constructor (packageB64Photo: string, ownerUserId: number, description: string, deliveryUnit: string ){
        this.packageB64Photo = [packageB64Photo],
        this.ownerUserId = ownerUserId,
        this.description = description,
        this.deliveryUnit = deliveryUnit
    }
}
